import React, { FC } from "react";
import { Container } from "../../../../components";
import { Heading } from "@telia/teddy";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { PAYMENT_METHOD, PaymentMethod } from "../../../../../../constants";
import { DeliveryMethod, RootState } from "../../../../../../models";
import * as LOADING_SELECTORS from "../../../../loading/state/selectors";
import { prepaidRefillTotalUpfrontPrice } from "../../../../prepaid/state/selectors";
import { VoucherTable } from "../../../../voucher";
import { setSelectedPaymentType } from "../../../state/actions/paymentActions";
import * as CHECKOUT_AT from "../../../state/actionTypes";
import {
    getNewNumberPrice,
    getTotalPriceFirstInvoice,
    getTotalPriceUpfront,
} from "../../../state/selectors/cartSelectors";
import { getEnhancedDeliveryInfoSelected } from "../../../state/selectors/deliveryInfoSelectors";
import { getPaymentMethods, getPaymentSelectedType } from "../../../state/selectors/paymentSelectors";
import TEXT from "../../../text-consts";
import AdyenPaymentMethod from "../../molecules/AdyenPaymentMethod/AdyenPaymentMethod";
import PaymentMethods from "../../molecules/PaymentMethods/PaymentMethods";

interface StateProps {
    isSubmittingOrder: boolean;
    paymentMethods: PaymentMethod[];
    selectedDeliveryMethod?: DeliveryMethod;
    selectedType?: PaymentMethod;
    totalFirstInvoicePrice: number;
    totalUpfrontPrice: number;
}

interface PaymentCardProps extends StateProps {
    hideVoucher?: boolean;
}

const PaymentCard: FC<PaymentCardProps> = ({
    isSubmittingOrder,
    paymentMethods,
    selectedType,
    totalUpfrontPrice,
    totalFirstInvoicePrice,
    selectedDeliveryMethod,
    hideVoucher = false,
}) => {
    const dispatch = useDispatch();
    const deliveryPrice = +_get(selectedDeliveryMethod, "price", 0);
    const amountToPay =
        selectedType === PAYMENT_METHOD.INVOICE
            ? totalFirstInvoicePrice + deliveryPrice
            : totalUpfrontPrice + deliveryPrice;

    return (
        <Container className="summary-container__section" size="small" whiteBg noPaddingTop>
            <Heading mb="100" as="h2" mt="150" variant="title-200">{`${TEXT.PAYMENT.HEADING}:`}</Heading>
            {!!amountToPay && (
                <PaymentMethods
                    isDisabled={isSubmittingOrder}
                    methods={paymentMethods}
                    selectedType={selectedType}
                    onChange={(...args) => dispatch(setSelectedPaymentType(...args))}
                />
            )}
            {!!amountToPay && selectedType === PAYMENT_METHOD.ADYEN_CC && (
                <AdyenPaymentMethod amountToPay={amountToPay} isDisabled={isSubmittingOrder} />
            )}
            {!hideVoucher && <VoucherTable />}
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isSubmittingOrder: LOADING_SELECTORS.isTypeLoading(state, CHECKOUT_AT.CHECKOUT_PAYMENT),
    paymentMethods: getPaymentMethods(state),
    selectedType: getPaymentSelectedType(state),
    selectedDeliveryMethod: getEnhancedDeliveryInfoSelected(state),
    totalUpfrontPrice: getTotalPriceUpfront(state) + prepaidRefillTotalUpfrontPrice(state),
    totalFirstInvoicePrice: getTotalPriceFirstInvoice(state) - getNewNumberPrice(state),
});

export default connect(mapStateToProps)(PaymentCard);
